//Authenticated
export const HOME = '/';

//Without Authenticated
export const LOGIN = '/login';
export const SERVICE_TRACKING = '/seguimientoservicio';
export const SURVEY = '/survey';
export const REQUEST_ACCOUNT = '/request-account';
export const VALIDATE_ACCOUNT = '/validate-account';
export const RESET_PASSWORD = '/reset-password';
export const CREATE_ACCOUNT = '/create-account';
export const ACTIVATE_ACCOUNT = '/activate-account';
export const CHANGE_PASSWORD = '/change-password';
export const FREQUENT_QUESTIONS = '/frequent-questions';
export const TERMS_AND_CONDITIONS = '/terms-and-conditions';
export const LEGAL_NOTICES = '/legal-notices';
export const CONTACT_US = '/contact-us';
export const DATA_PRIVACY_TERMS = '/data-privacy-terms';
export const ASSISTANCE_REQUEST = '/assistance-request/:id';
export const ERROR_PAGE = '/error-page';
export const VALIDATE_BOOKING = '/validate-booking/:id';
export const BOOKINGS = '/bookings';
export const MYASSISTS = '/assists';
export const VALIDATE_TEMPORAL_PASSWORD = '/validate-temporal-password';
